module.exports = __webpack_public_path__ + "img/shipo-map-tug.4cc43a95.svg";